module.exports = __webpack_public_path__ + "img/ax_logomark.5558410a.svg";